const ONE_MINUTE_IN_MILLISECONDS = 60000;

export const minutesToMilliseconds = (minutes: number) =>
  ONE_MINUTE_IN_MILLISECONDS * minutes;
